import { Box, Typography, Button, Stack, Paper, TableContainer } from "@mui/material";
import { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {PARTICIPANT_CONNECTORS} from "../config/settings";
import Grid from '@mui/material/Grid2';

export default function ParticipantListOfConnectors(props) {
    const navigate = useNavigate();
    const [connectors, setConnectors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const participant = props.participant;

    // console.log(participant);

    useEffect(() => {
        fetchConnectors();
      }, []);

    const handleEdit = (connector) => {
        navigate(`/connector-form/${connector.id}`, { state: { connector } });
    };

    const fetchConnectors = async () => {
        try {
          const response = await axios.get(PARTICIPANT_CONNECTORS);
          setConnectors(response.data);
          // console.log(response.data);
          setLoading(false);
        } catch (err) {
          setError(err);
          setLoading(false);
        }
      };

    if (!connectors || connectors.length === 0) {
        return <></>;
    }

    const columns = [
        { field: "name", headerName: "Connector Name", flex: 1 },
        { field: "participant_name", headerName: "Participant Name", flex: 1 },
        { field: "enabled", headerName: "Enabled", flex: 0.5, renderCell: (params) => (params.value ? "true" : "false") },
        { field: "is_up", headerName: "Is Up", flex: 0.5, renderCell: (params) => (params.value ? "true" : "false") },
        { field: "connector_url", headerName: "Connector URL", flex: 1.5 },
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            filterable: false,
            flex: 0.5,
            renderCell: (params) => (
                <Button disabled={participant?.management?.approval_status === "WITHDRAWN" || participant?.management?.approval_status === "SUSPENDED"} variant="contained" color="primary" size="small" onClick={() => handleEdit(params.row)}>
                    Edit
                </Button>
            ),
        },
    ];

    return (
        <>
            <TableContainer
                component={Paper}
                style={{ padding: "20px", marginTop: "1em" }}
            >
                <Stack spacing={2}>
                    <Typography variant="h5" sx={{ mb: 1, mt: 5, color: "#213270" }}>
                        Registered Connectors
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2, mt: 2 }}>
                        Manage and review the connectors linked to the system.
                    </Typography>

                    <Box sx={{ width: "100%" }}>
                        <DataGrid
                            rows={connectors}
                            columns={columns}
                            getRowId={(row) => row.uuid}
                            loading={loading}
                            pageSize={5}
                            rowsPerPageOptions={[5, 10, 20]}
                            disableSelectionOnClick
                        />
                    </Box>

                </Stack>
            </TableContainer>
        </>
    );
}
